module.exports = __webpack_public_path__ + "static/img/19-0919_1.7a48379.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsDetail/images/19-0919_1.jpg
// module id = OiMv
// module chunks = 0